import { createWebSocketStore } from 'src/components/#services/helpers';
export const getSecretKey = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_getSecret',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const enableTwoFactor = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_enableTwoFA',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const disableTwoFactor = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_disableTwoFA',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const verifyCode = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_verifyCode',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const isRequiredTwoFA = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_isRequiredTwoFA',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const disableTwoFactorRequest = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_sendRequestToDeleteTwoFA',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
export const deleteTwoFactorConfirm = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'twoFactor_deleteTwoFA',
        agent: 'auth',
        lang: 'en',
        auth: {
            type: 'webSite',
        },
    },
});
